import { Component, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';

@Component({
  selector: 'app-new-visit',
  imports: [DotPulseComponent],
  templateUrl: './new-visit.component.html',
  styleUrl: './new-visit.component.scss',
})
export class NewVisitComponent {
  claimType = input.required<'repair' | 'service'>();
  isFirstVisit = input.required<boolean>();
  isTvRemoteReplacement = input.required<boolean>();
}
